import styled from '@emotion/styled'
import { Divider as MuiDivider, Grid2 as Grid } from '@mui/material'
import { spacing } from '@mui/system'
import React from 'react'

import DaiLogo from '../DaiLogo'

const Footer = styled.div`
  background-color: ${props =>
    props.theme.sidebar.footer.background} !important;
  padding: ${props => props.theme.spacing(2.75)}
    ${props => props.theme.spacing(4)};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`

const Divider = styled(MuiDivider)(spacing)

const SidebarFooter: React.FC = ({ ...rest }) => {
  return (
    <Footer {...rest}>
      <Divider my={0} />
      <Grid container sx={{ alignItems: 'center', justifyContent: 'center' }}>
        {<DaiLogo sx={{ width: 150, marginBottom: 0 }} />}
      </Grid>
    </Footer>
  )
}

export default SidebarFooter
